// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMediaForward = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m5.5 16.393 5.417-3.907L5.5 8.603zM11 8.384c0-1.106 1.233-1.78 2.162-1.157h.001l6.303 4.115a1.394 1.394 0 0 1 0 2.315l-6.303 4.097-.001.002c-.93.622-2.162-.052-2.162-1.158v-2.36l-4.837 3.516-.001.002C5.232 18.378 4 17.704 4 16.598v-8.2c0-1.106 1.233-1.78 2.162-1.157h.002L11 10.734zm1.5 8.009 6-3.893-6-3.91z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgMediaForward;
